import React, { useEffect, useState } from "react";
import { Snackbar, TextField } from "@material-ui/core";

import ErrorAlert from "../../components/layouts/ErrorAlert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import DetailsBillAchat from "./DetailsBillAchat";
import { Alert } from "@material-ui/lab";

import ExtratFacture from "../../models/ExtratFacture";
import SocieteFactureBox from "../../models/SocieteFactureBox";
import MethodePayementBillTotal from "./payement/MethodePayementBillTotal";
import MethodePayementBillAvance from "./payement/MethodePayementBillAvance";
import ListAvancePayementBC from "./payement/ListAvancePayementBC";
import ListTotalPayementBill from "./payement/ListTotalPayementBill";
import BCService from "../../services/BC";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../layouts/WithLoader";
import UtilsFormule from "../../utils/UtilsFormule";
import SimulateRetenuAchat from "./SimulateRetenuAchat";
import TierAccountService from "../../services/PayementSolde/TierAccountService";

const PayementBillDetails = ({ startLoading, stopLoading }) => {

  const [alert_message, setAlert_message] = useState("");
  const [ChoosePayement, setChoosePayement] = useState("");
  const [certificatRetenu, setCertificatRetenu] = useState(false);
  const [buttonClicked, setButtonClicked] = useState("");
  const [amountMax, setAmountMax] = useState("");
  const [companyInfo, setCompanyInfo] = useState("");
  const [restToPay, setRestToPay] = useState(0);
  const [totalHT, setTotalHT] = useState(0);
  const [totalTT, setTotalTT] = useState(0);
  const [factureInformation, setFactureInformation] = useState("");
  const [payementInformations, setPayementInformations] = useState(0);
  const [totalPayementInformation, setTotalPayementInformation] = useState(0);
  const [typeWallet, setTypeWallet] = useState(false);
  const [onSimulate, setOnSimulate] = useState(false);
  const [simulateData, setSimulateData] = useState();
  const [percenteRetenu, setPercenteRetenu] = useState(0);
  const [amountRetenu, setAmountRetenu] = useState(0);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [devise, setDevise] = useState();
  const [tauxChange, setTauxChange] = useState();
  const [finalPriceAfterExchangeRate, setFinalPriceAfterExchangeRate] = useState(0);
  const [finalPriceHTCAfterExchangeRate, setFinalPriceHTCAfterExchangeRate] = useState(0);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [wallet, setWallet] = useState();


  useEffect(() => {
    startLoading();
    BCService.getDocumentForPayementTask(localStorage.getItem("idBill"), "1")
      .then((response) => {
        localStorage.setItem("company", response.data["company"].title)
        localStorage.setItem("adresse", response.data["supplier"].adresse)
        localStorage.setItem("client", response.data["supplier"].title)
        if (response.data["success"]) {
          let montantR = 0;
          setCompanyInfo(response.data["company"]);
          setFactureInformation(response.data["success"]);
          if (response.data["success"].isImport === 2) {
            setDevise(response.data["success"].purchases[0].currency)
          }
          if (response.data["success"].finalPriceHT) {
            setTotalHT(response.data["success"].finalPriceHT);
          } else {
            setTotalHT(response.data["success"].buyinfPrice);
          }
          if (response.data["success"].finalPriceTt) {
            setTotalTT(response.data["success"].finalPriceTt);
            montantR = response.data["success"].finalPriceTt;

          } else {
            setTotalTT(response.data["success"].priceTT);
            montantR = response.data["success"].priceTT;

          }
          setRestToPay(montantR);


          console.log("clientInfo", response.data["supplier"].id)
          localStorage.setItem("idTierWallet", response.data["supplier"].id);
          TierAccountService.getWalletByTierFournisseur(getCurrentUserId(), response.data["supplier"].id)
            .then((response) => {
              if (response.data.success) {

                setTypeWallet(true);
                setWallet(response.data.success);
              }
            })
            .catch((error) => {
              setAlert_message("error " + error);
            })
        }
      })
      .catch((error) => {
        setAlert_message("error" + error);
      });

    BCService.getFacturePayementInformation(
      localStorage.getItem("idBill"),
      "FACTURE"
    )
      .then((response) => {
        if (response.data["Payement"]) {
          setPayementInformations(response.data["Payement"]);

          if (response.data["Payement"]?.id != null) {
            setRestToPay(response.data["Payement"]?.restToPay);
          }
        } else if (response.data["PayementTotal"]) {
          setTotalPayementInformation(response.data["PayementTotal"]);
        }
      })
      .catch((error) => {
        setAlert_message("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setChoosePayement(payement);
  };

  function payementChooseUI() {
    if (ChoosePayement === "TOTAL") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">2-Deuxième étape:</h3>
                </div>
                {/* hereTotal */}

                <MethodePayementBillTotal
                  typeWallet={typeWallet}
                  wallet={wallet}
                  restToPay={Number(restToPay.toFixed(3))}
                />
              </div>
            </div>
          </div>
        </section>
      );
    } else if (ChoosePayement === "AVANCE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">2-Deuxième étape: </h3>
              </div>
              <MethodePayementBillAvance
                typeWallet={typeWallet}
                wallet={wallet}
                restToPay={Number(restToPay.toFixed(3))}
              />
            </div>
          </div>
        </div>
      );
    }
  }
  const changePercentRetenu = (event) => {
    console.log("event", event.target.value);
    setPercenteRetenu(event.target.value);
  };

  const changeExchangeRate = (event) => {
    setTauxChange(event.target.value);
  };

  const changeAmountRetenu = (event) => {
    setAmountRetenu(event.target.value);
  };

  const changeFinalPriceAfterExchangeRate = (event) => {
    setFinalPriceAfterExchangeRate(event.target.value);
  };

  const changeFinalPriceHTCAfterExchangeRate = (event) => {
    setFinalPriceHTCAfterExchangeRate(event.target.value);
  };
  const certificatUIResult = () => {
    if (certificatRetenu) {
      if (factureInformation?.retenuSource === null) {
        return (
          <div class="col-12">
            <div className="card card-outline card-dark">
              <div className="card-body">
                <div className="form-group files color">
                  <div class="row">
                    <div className="col-md-12">
                      <div class="row">
                        <div className="col-md-6">
                          <label>Choisir le pourcentage de retenu: </label>
                          <input
                            type="number"
                            min="0"
                            step="0.1"
                            class="form-control"
                            name="amount"
                            // defaultValue={percenteRetenu}
                            onChange={(e) => changePercentRetenu(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Choisir le montant de retenu: </label>
                          <input
                            type="number"
                            min="0"
                            step="0.1"
                            class="form-control"
                            name="amount"
                            // defaultValue={percenteRetenu}
                            onChange={(e) => changeAmountRetenu(e)}
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>


                  <br />
                  <div className="row">
                    <div class="col-md-10"></div>

                    <div className="col-md-1">
                      <button
                        className="btn btn-dark float-right"
                        onClick={generateAndDownloadRetenu}
                      >
                        <i class="fas fa-download"></i> Générer
                      </button>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-dark float-right"
                        data-toggle="modal"
                        data-target="#simuler-retenu"
                        onClick={onSimulateRetenu}
                      >
                        <i class="fas fa-eye"></i> Simuler
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
    if (
      factureInformation?.retenuSource !== null &&
      factureInformation?.retenuSource?.creationDate !== null
    ) {
      return (
        <div class="col-12">
          <div className="card card-outline card-dark">
            <div class="card-header">
              <h3 class="card-title">
                Retenu à la source généré le{" "}
                {UtilsFormule.formatDate(
                  factureInformation?.retenuSource?.creationDate
                )}
              </h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                  title="Collapse"
                >
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="form-group files color">
                <div class="row">
                  <div class="col-md-12">
                    <label>
                      Montant du retenu :
                      {factureInformation?.retenuSource?.retenuAmmount} TND{" "}
                    </label>
                  </div>
                  <div class="col-md-12">
                    <label>
                      Pourcentage de retenu:{" "}
                      {factureInformation?.retenuSource?.retenuPercent} %{" "}
                    </label>
                  </div>

                  <div className="col-md-12">
                    <button
                      className="btn btn-dark float-right"
                      onClick={(e) => generateAndDownloadRetenu(e)}
                    >
                      <i class="fas fa-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  const onSimulateRetenu = () => {
    let simulData = {
      idDocument: factureInformation?.id,
    };
    setSimulateData(simulData);
    setOnSimulate(true);
  };

  const generateAndDownloadRetenu = (e) => {
    // retenuUrl, id
    if (factureInformation?.retenuSource !== null) {
      onShowFileInOtherWizndowHandler(
        factureInformation.retenuSource.retenuUrl
      );
      // setTimeout(() => {
      //   window.location.reload(true);
      // }, 50);
    } else {
      startLoading();
      BCService.generateRetenuSourceV2(
        getCurrentUserId(),
        percenteRetenu,
        amountRetenu,
        factureInformation.id
      )
        .then((response) => {
          console.log("response ", response);
          if (response.data["path"]) {
            onShowFileInOtherWizndowHandler(response.data["path"]);
            // setTimeout(() => {
            //   window.location.reload(true);
            // }, 50);
          } else {
            toast.error("Erreur : il y'a un probléme au niveau de serveur");
          }
        })
        .catch((error) => {
          toast.error("Erreur : " + error);
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+error);
      });
  };
  const getAvancesPayementBC = () => {
    if (payementInformations?.id != null) {
      if (payementInformations?.bonDeCommande?.id != null) {
        return (
          <ListAvancePayementBC
            idBC={payementInformations?.bonDeCommande["id"]}
          />
        );
      } else {
        return <div className="col-12"></div>;
      }
    }
  };
  const buttonPayement = () => {
    if (parseFloat(amountMax) === 0) {
      return <div className="col-md-12"></div>;
    } else if (
      payementInformations?.id != null &&
      parseInt(payementInformations?.restToPay) <
      parseInt(factureInformation?.buyinfPrice) &&
      parseInt(payementInformations?.restToPay) !== 0
    ) {
      return (
        <button
          type="submit"
          onClick={(e) => {

            setButtonClicked("clicked");
          }}
          className="btn btn-dark float-right"
        >
          Continuer le payement
        </button>
      );
    } else if (
      (payementInformations?.id != null &&
        parseInt(payementInformations?.restToPay) ===
        parseInt(factureInformation?.buyinfPrice)) ||
      factureInformation?.payed === 0
    ) {
      return (
        <button
          type="submit"
          onClick={(e) => {
            setButtonClicked("clicked");
          }}
          className="btn btn-dark float-right"
        >
          Commencer le payement
        </button>
      );
    } else {
      return <div className="col-12"></div>;
    }
  };
  function refreshPage() {
    window.location.reload(false);
  }
  const finaliserBill = (e) => {
    BCService.finaliserPayement(1, factureInformation?.id)
      .then((response) => {
        if (response.data.error) {
          toast.error("Error : il ya un probléme");
        } else {
          toast.success("Opération avec succès");

          refreshPage();
        }
      })
      .catch((error) => {
        toast.error("Error : il ya un probléme");

        refreshPage();
      });
  };
  const retenubtnPayement = () => {
    if (factureInformation?.retenuSource === null) {
      return (
        <button
          type="submit"
          onClick={(e) => {
            setCertificatRetenu(true);
          }}
          className="btn btn-dark float-right"
        >
          Retenu
        </button>
      );
    }
  };
  const buttonFinaliserPayement = () => {
    if (factureInformation?.payed === 1) {
      return null;
    } else {
      return (
        <button
          type="submit"
          onClick={(e) => {
            finaliserBill();
            // setButtonClicked("clicked");
          }}
          className="btn btn-dark"
        >
          Finaliser le payement
        </button>
      );
    }
  };
  const DynamiquePayement = () => {
    if (buttonClicked === "clicked") {
      return (
        <section className="content">
          <div className="row">
            <div className="col-12">
              <div className="card card-dark ">
                <div className="card-header">
                  <h3 className="card-title">1-Première étape: </h3>
                  <br />
                </div>

                <div className="card-body">
                  <h5 className="card-title">
                    Choisir de payer la totalité du montant ou une avance
                  </h5>
                  <div className="row">
                    <div className="col-2"></div>
                    <div className="col-10">
                      <select
                        className="form-control"
                        onChange={handleChangePayement}
                      >
                        <option key={0} value={0}>
                          Payer
                        </option>
                        <option key={1} value={"TOTAL"}>
                          La totalité du montant
                        </option>
                        <option key={2} value={"AVANCE"}>
                          Une avance
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {payementChooseUI()}
        </section>
      );
    }
  };
  const ChangeExchangeRateAndPrice = () => {

    if (tauxChange === undefined || tauxChange === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le Taux de change est vide ");
    } else if (finalPriceAfterExchangeRate === undefined || finalPriceAfterExchangeRate === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le prix final est vide ");
    } else if (finalPriceHTCAfterExchangeRate === undefined || finalPriceHTCAfterExchangeRate === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le prix HTC final est vide ");
    } else {
      startLoading();
      BCService.changeExchangeRatePayement(
        getCurrentUserId(),
        factureInformation?.id,
        tauxChange, devise,
        finalPriceHTCAfterExchangeRate,
        finalPriceAfterExchangeRate
      )
        .then((response) => {
          console.log("response ", response);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            window.location.reload(true);
          }, 2000);
        })
        .catch((error) => {
          toast.error("Erreur : " + error);
        })
        .finally(() => {
          stopLoading();
        });

    }

  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const PayementImport = () => {
    if (factureInformation?.isImport !== 0 && factureInformation?.isImport !== 1) {
      if (factureInformation?.isImport === 2 && (factureInformation?.devise === undefined || factureInformation?.devise === null || factureInformation?.devise === "TND")) {
        return (<div class="col-12">
          <div className="card card-dark">
            <div className="card-header">
              <b> Facture en devise </b>
            </div>
            <div className="card-body">
              <div className="form-group files color">
                <div class="row">
                  <div className="col-md-12">
                    <div class="row"><label>Devise: {devise} </label>
                    </div>
                    <div class="row">
                      <div className="col-md-4">
                        <label>Saisir Taux de change </label>
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          class="form-control"
                          name="amount"
                          onChange={(e) => changeExchangeRate(e)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Saisir le prix final HTC en DNT: </label>
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          class="form-control"
                          name="amount"
                          onChange={(e) => changeFinalPriceHTCAfterExchangeRate(e)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Saisir le prix final TTC en DNT: </label>
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          class="form-control"
                          name="amount"
                          onChange={(e) => changeFinalPriceAfterExchangeRate(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                </div>


                <br />
                <div className="row">
                  <div class="col-md-10"></div>

                  <div className="col-md-2">
                    <button
                      className="btn btn-dark float-right"
                      onClick={ChangeExchangeRateAndPrice}
                    >
                      <i class="fas fa-download"></i> Valider
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>)
      } else {
        return (<div class="col-12">
          <div className="card card-dark">
            <div className="card-header">
              <b> Facture en devise </b>
            </div>
            <div className="card-body">
              <div className="form-group files color">
                <div class="row">
                  <div className="col-md-12">
                    <div class="row"><label>Devise: {devise} </label>
                    </div>
                    <div class="row"><label>Taux de change: {factureInformation?.tauxChange} </label>
                    </div>

                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>)

      }
    }

  }

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {alert_message === "error" ? (
        <>
          <section className="content">
            <br />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <ErrorAlert message="Désolé aucune facture à afficher" />
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          <ToastContainer />
          <div className="container-fluid">
            <br />
            <section className="invoice p-3 mb-3">
              <div className="col-xs-12">
                <h2 className="page-header">
                  <i className="fas fa-globe-africa" />
                  {factureInformation?.title}
                  <small className="float-right">
                    Date:{" "}
                    {UtilsFormule.formatDate(factureInformation?.createionDate)}
                  </small>
                </h2>
              </div>

              <div className="row invoice-info">
                <div className="col-sm-6 invoice-col">
                  Détails Facture
                  <address>
                    <strong>
                      {factureInformation?.ref}-{factureInformation?.title}
                    </strong>
                    <br />
                    {factureInformation?.note != null
                      ? factureInformation?.note
                      : "Vide"}
                    <br />
                  </address>
                </div>
                <SocieteFactureBox societe={companyInfo} role="Emetteur" />
                <SocieteFactureBox
                  societe={factureInformation?.supplier}
                  role="Fournisseur"
                />
              </div>

              <div className="row">
                <div class="col-6"></div>
                <div class="col-6">
                  <ExtratFacture
                    extracts={factureInformation?.purchases}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6"></div>
                <div className="col-4">
                  <div className="table-responsive ">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th style={{ width: "50%" }}>Total HT:</th>
                          <td>{totalHT} {devise}</td>
                        </tr>

                        <tr>
                          <th>Timbre:</th>
                          <td>{factureInformation?.timbre}</td>
                        </tr>
                        <tr>
                          <th>Total TT:</th>
                          <td>{totalTT} {devise}</td>
                        </tr>

                        <tr>
                          <th>Reste à payer:</th>
                          <td>{Math.round(restToPay * 1000) / 1000} </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
              <div className="box-footer"></div>
              <br />
              <br />
            </section>
            {/* {certificatUIResult()} */}
            {getAvancesPayementBC()}
            {payementInformations?.id != null ? (
              <ListTotalPayementBill
                payementInformations={
                  payementInformations?.payementInformationFacture
                }
              />
            ) : totalPayementInformation?.idPayementTotal != null ? (
              <ListTotalPayementBill
                totalPayementInformation={totalPayementInformation}
              />
            ) : null}
            <br />

            {PayementImport()}
            <div className="row float-right">
              <div class="col-12">{retenubtnPayement()}</div>
            </div>
            <br />

            <div className="row">{certificatUIResult()}</div>
            <br />
            {buttonPayement()}
            <br />
            <br />
            {buttonFinaliserPayement()}
            <br />
            <br />
            {DynamiquePayement()}

          </div>
        </>
      )}
      {onSimulate && (
        <SimulateRetenuAchat
          setOnSimulate={setOnSimulate}
          simulateData={simulateData}
        />
      )}
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(PayementBillDetails);
